export const BannerTwo = () => {
  return (
    <section className='Section 5'>
      <div className='banner-two'>
        <div className='banner-two__content'>
          <div className='bg-img'>
            <img
              className='banner-two-desktop'
              src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1669065656/Navidad-2/Lippi/FOTO_l2gql3.jpg'
              alt=''
            />
            <img
              className='banner-two-mobile'
              src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1669065732/Navidad-2/Lippi/FONDO_lxppqh.jpg'
              alt=''
            />
          </div>
          <div className='text text-banner-2'>
            <img
              className='upcycling'
              src='https://res.cloudinary.com/lippi-outdoor/image/upload/v1671120021/Upcycling/Logo_upcycling_iwx9ck.png'
              alt=''
            />
            <h2>De desechos</h2>
            <h2>a hechos</h2>
            <div className='btn-white'>
              <a
                href='https://www.lippioutdoor.com/upcycling'
                target='_parent'
                id='c5-1'
              >
                Ver Productos
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
